module.exports = __webpack_public_path__ + "static/media/zone_filled.14008414.png";